export {
  mergeAndRankResults,
  deduplicateResults,
  normalizeScores,
} from './merger'

export {
  extractSearchableFields,
  extractHashOnlyFields,
  classifyFields,
  type EncryptionMapEntry,
  type FieldExtractionConfig,
} from './field-policy'
